import { render, staticRenderFns } from "./WarehouseStockManagement.vue?vue&type=template&id=037609f8&"
import script from "./WarehouseStockManagement.vue?vue&type=script&lang=js&"
export * from "./WarehouseStockManagement.vue?vue&type=script&lang=js&"
import style0 from "./WarehouseStockManagement.vue?vue&type=style&index=0&id=037609f8&prod&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports